import React from "react";
import PropTypes from "prop-types";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { Icon } from "MODULES/shared/components";
import {
  REPAIR_EVALUATION_REJECTED,
  WORKING_TO_SAVE_UNIT,
  REPAIR_EVALUATION_APPROVED,
  NO_WORK_PERFORMED,
  REPAIR_EVALUATION_RECEIVED
} from "MODULES/inventories/constants";

export default function RequiredComponent({ toggleComponentModal, lineItem }) {
  if (!lineItem) return null;
  if (
    ![
      REPAIR_EVALUATION_RECEIVED,
      NO_WORK_PERFORMED,
      REPAIR_EVALUATION_APPROVED,
      REPAIR_EVALUATION_REJECTED,
      WORKING_TO_SAVE_UNIT
    ].includes(lineItem.approval_status)
  ) {
    return null;
  }

  return (
    <DropDownItem onClick={toggleComponentModal}>
      <Icon name="check" fixed />
      Create Required Component
    </DropDownItem>
  );
}

RequiredComponent.propTypes = {
  lineItem: PropTypes.shape({}),
  toggleComponentModal: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/RequiredComponents/RequiredComponent.jsx